import type { FC } from 'react';
import { motion } from 'framer-motion';

interface BuildingProgressBarProps {
  current: number;
  target: number;
  label?: string;
  color?: string;
}

export const BuildingProgressBar: FC<BuildingProgressBarProps> = ({
  current,
  target,
  label = 'Progress',
  color = '#3B82F6'
}) => {
  const percentage = Math.min((current / target) * 100, 100);
  const isComplete = current >= target;

  return (
    <div className="w-full">
      <div className="mb-1 flex items-center justify-between text-xs">
        <span className="text-white/60">{label}</span>
        <span className={isComplete ? 'font-semibold text-green-400' : 'text-white/60'}>
          {current.toLocaleString()} / {target.toLocaleString()}
        </span>
      </div>

      <div className="h-2 overflow-hidden rounded-full bg-white/10">
        <motion.div
          className="h-full rounded-full"
          style={{
            background: isComplete
              ? 'linear-gradient(90deg, #10B981, #34D399)'
              : `linear-gradient(90deg, ${color}, ${color}dd)`
          }}
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.45, ease: 'easeOut' }}
        />
      </div>

      {isComplete && (
        <motion.div
          initial={{ opacity: 0, scale: 0.75 }}
          animate={{ opacity: 1, scale: 1 }}
          className="mt-1 text-center text-xs font-semibold text-green-400"
        >
          ✓ Ready to buy!
        </motion.div>
      )}
    </div>
  );
};

